import React from 'react';
import CookieConsent from 'react-cookie-consent';

const CookieAlert = () => (
  <CookieConsent
    location="bottom"
    buttonText="I ACCEPT"
    cookieName="smm-cookie-policy-accept"
    style={{ background: 'rgb(6, 167, 224)' }}
    buttonStyle={{
      color: 'rgb(6, 167, 224)',
      backgroundColor: '#fff',
      fontSize: '13px',
      fontWeight: 700,
      borderRadius: '5px',
    }}
    buttonId="policyButton"
    expires={150}
  >
    We use cookies to improve your experience on smm.org.
    Browsing this site means you accept the use of cookies and our privacy terms.
    <br />
    Read our&nbsp;
    <span className="policy">
      <a target="_blank" rel="noopener noreferrer" href="https://www.smm.org/privacy">privacy terms and conditions</a>
    </span>
    &nbsp;to learn more.
  </CookieConsent>
);

export default CookieAlert;
